import {
  Progress,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Box,
} from "@chakra-ui/react";
import useMinhasFormaPagamentos from "core/features/forma-pagamento/hooks/useMinhasFormaPagamentos";
import MethodItem from "./MethodItem";

export default function TabelaFormasRecebimento({
  tenantId,
  ativo,
  value,
  onChange,
  hideTaxas,
}: {
  tenantId: string;
  ativo?: "1" | "0";
  value: string[];
  onChange: (v: string[]) => void;
  hideTaxas?: boolean;
}) {
  const { isLoading, data } = useMinhasFormaPagamentos(tenantId, ativo);

  const isChecked = (id: string) => {
    return value?.includes(id);
  };

  const handleChange = (id: string) => {
    if (isChecked(id)) {
      onChange(value?.filter((v) => v !== id));
    } else {
      onChange([...(value ?? []), id]);
    }
  };
  return (
    <Box>
      {isLoading ? (
        <Progress
          size="sm"
          isIndeterminate
          w="100%"
          my={4}
          colorScheme="cyan"
        />
      ) : null}

      <Text mb={4} fontSize="18px" fontWeight="bold">
        Métodos de Cobrança
      </Text>
      <Table
        variant="unstyled"
        sx={{ "border-collapse": "separate", "border-spacing": "0 16px" }}
      >
        <Thead>
          <Tr>
            <Th />
            {!hideTaxas && <Th w="120px" textTransform="capitalize" fontWeight="normal">
              Taxa
            </Th>}
            <Th w="130px" textTransform="capitalize" fontWeight="normal">
              Habilitado
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.map((item, index) => (
            <MethodItem
              onChange={() => handleChange(item.id)}
              value={isChecked(item.id)}
              item={item}
              key={index}
              hideTaxas={hideTaxas}
            />
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}
